import React from 'react';
import './ProductSkeleton.css';

const ProductSkeleton = () => {
  return (
    <div className="product-skeleton">
      <div className="skeleton-image-wrapper">
        <div className="skeleton-image"></div>
      </div>
      <div className="skeleton-info">
        <div className="skeleton-name"></div>
        <div className="skeleton-rating">
          <div className="skeleton-stars"></div>
          <div className="skeleton-provider"></div>
        </div>
        <div className="skeleton-price-section">
          <div className="skeleton-price"></div>
          <div className="skeleton-button"></div>
        </div>
        <div className="skeleton-additional-prices"></div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
